module.exports = __webpack_public_path__ + "static/media/rode-true.e9b47aef.jpg";